import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import api from "../../lib/api";
import AdminGroups from "./AdminGroups";
import AdminDeals from "./AdminDeals";
import { Members } from "./tabs/Members";
import { Holdings } from "./tabs/Holdings";
import { AdminDocuments } from "./tabs/AdminDocuments";
import { Commitments } from "./tabs/Commitments";
import { AdminTransfers } from "./tabs/AdminTransfers";
import { SPVs } from "./tabs/SPVs";
import { Overview } from "./tabs/Overview";
import { Pipeline } from "./tabs/Pipeline";
import { Questions } from "./tabs/Questions";
import { Messages } from "./tabs/Messages";
import { Inbox } from "./tabs/Inbox";
import { AuditLog } from "./tabs/AuditLog";
import { ReturnsEditor } from "./tabs/ReturnsEditor";
import { EmailStudio } from "./tabs/EmailStudio";
import { Settings } from "./tabs/Settings";

const TABS = ["Overview", "Members", "Deals", "Pipeline", "SPVs", "Holdings", "Documents", "Commitments", "Transfers", "Questions", "Messages", "Inbox", "Groups", "Audit", "Returns", "Emails", "Settings"];

export default function Admin() {
  const [tab, setTab] = useState("Overview");
  const [inboxCount, setInboxCount] = useState(0);
  const [dealsEditId, setDealsEditId] = useState(null);
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCounts = () => api.get("/admin/inbox/counts").then((r) => setInboxCount(r.data.total)).catch(() => {});
    fetchCounts();
    const id = setInterval(fetchCounts, 45000);
    return () => clearInterval(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    api.get("/admin/inbox/counts").then((r) => setInboxCount(r.data.total)).catch(() => {});
  }, [tab]);

  return (
    <div className="min-h-screen">
      <header style={{ borderBottom: "1px solid var(--rule)" }}>
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between gap-6 flex-wrap">
          <Link to="/app" className="flex items-center gap-3">
            <span className="solera-symbol" />
            <span className="wordmark text-bone text-sm">Solera</span>
            <span className="t-label ml-2">Admin</span>
          </Link>
          <div className="flex items-center gap-5">
            <Link to="/app" className="t-label hover:!text-[#E8E6E1]" data-testid="admin-member-view-link">Member view</Link>
            <button onClick={async () => { await logout(); navigate("/login"); }} className="t-label hover:!text-[#E8E6E1]" data-testid="admin-logout-button">Logout</button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-12" data-testid="admin-page">
        <nav className="flex flex-wrap gap-x-6 gap-y-3 pb-2" data-testid="admin-tabs">
          {TABS.map((t) => (
            <button key={t} onClick={() => setTab(t)}
              className={`t-label pb-1 border-b shrink-0 transition-colors duration-150 ${tab === t ? "border-[#E8E6E1] !text-[#E8E6E1]" : "border-transparent hover:!text-[#E8E6E1]"}`}
              data-testid={`admin-tab-${t.toLowerCase()}`}>
              {t}
              {t === "Inbox" && inboxCount > 0 && (
                <span className="ml-1.5 px-1.5 py-0.5 text-[10px] fig align-middle"
                  style={{ background: "#C69A4E", color: "#0E1012" }}
                  data-testid="inbox-tab-badge">{inboxCount}</span>
              )}
            </button>
          ))}
        </nav>
        <div className="mt-10">
          {tab === "Overview" && <Overview />}
          {tab === "Members" && <Members />}
          {tab === "Deals" && <AdminDeals initialEditId={dealsEditId} onConsumeEdit={() => setDealsEditId(null)} />}
          {tab === "Pipeline" && <Pipeline onPromoted={(id) => { setDealsEditId(id); setTab("Deals"); }} />}
          {tab === "SPVs" && <SPVs />}
          {tab === "Holdings" && <Holdings />}
          {tab === "Documents" && <AdminDocuments />}
          {tab === "Commitments" && <Commitments />}
          {tab === "Transfers" && <AdminTransfers />}
          {tab === "Questions" && <Questions />}
          {tab === "Messages" && <Messages />}
          {tab === "Inbox" && <Inbox />}
          {tab === "Groups" && <AdminGroups />}
          {tab === "Audit" && <AuditLog />}
          {tab === "Returns" && <ReturnsEditor />}
          {tab === "Emails" && <EmailStudio />}
          {tab === "Settings" && <Settings />}
        </div>
      </main>
    </div>
  );
}
